import React from 'react';
import PropTypes from 'prop-types';

import {
  Image,
  ExtendedBox,
} from '../../..';

const InvestmentCardImage = ({
  imageUrl,
  hover,
  desaturate,
  ImageWrapper,
  imageWrapperProps,
}) => {
  return (
    <ExtendedBox
      w={1}
      height={[165, 165, 220, 220, 265]}
      overflowX="hidden"
      overflowY="hidden"
    >
      <ImageWrapper
        // eslint-disable-next-line
        {...imageWrapperProps}
      >
        <Image
          w={1}
          src={imageUrl}
          hoverColorize
          desaturate={desaturate}
          hover={hover}
          transition="0.2s linear filter"
        />
      </ImageWrapper>
    </ExtendedBox>
  );
};

InvestmentCardImage.propTypes = {
  imageUrl: PropTypes.string,
  desaturate: PropTypes.string,
  hover: PropTypes.bool,
  ImageWrapper: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.symbol,
  ]),
  imageWrapperProps: PropTypes.object,
};

InvestmentCardImage.defaultProps = {
  imageUrl: '',
  hover: false,
  ImageWrapper: PropTypes.instanceOf(React.Fragment),
  imageWrapperProps: {},
};

export default InvestmentCardImage;
